<!--
 * @Author: FengXiao
 * @Date: 2020-07-26 10:41:37
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-14 18:05:06
-->
<!-- 现场 详情 -->
<template>
  <div class="activity-detail-page page-container">
    <video-player :datas="videoData">
      <div class="video-right-bl" slot="right-area">
        <div class="info-wrap">
          <div class="video-title">
            {{ pageData.title }}
          </div>
          <div class="activity-list">
            <div class="activity-item" v-for="(arr, key) in screeningData" :key="key">
              <div class="activity-date-wrap">
                <span class="activity-date_label">日期：</span>
                <span class="activity-date">{{ key }}</span>
              </div>
              <div class="activity-info">
                <div class="screening" v-for="item in arr" :key="item.label">
                  {{ item.label }}
                </div>
              </div>
            </div>
          </div>
          <div class="address"><span class="label">地点：</span>{{ pageData.activity_address }}</div>
        </div>
        <div class="video-actions-bl" v-if="+pageData.status === 2">
          <!-- 隐私改版：购票涉及用户信息，引导打开一席小程序 -->
          <button class="buy_class-btn" @click="gotoLogin">打开一席小程序购票</button>
        </div>
      </div>
    </video-player>
    <div class="content">
      <template v-for="(info, i) in speakers">
        <div class="speaker-info-wrap" v-if="info.data.length" :key="`speaker_${i}`">
          <div class="main-tlte">{{ info.title }}</div>
          <div class="detail-bl" v-for="item in info.data" :key="item.id">
            <div class="left-bl">
              <div class="speaker_photo">
                <img :src="item.avatar" alt="" class="speaker_photo-img" />
              </div>
              <div class="bottom-area">
                <div class="speaker_name">{{ item.name }}</div>
                <div class="speaker_intro">
                  <span>
                    {{ item.intro }}
                  </span>
                </div>
              </div>
            </div>
            <div class="right-bl">
              <div class="intro-bl">
                <i class="iconfont icondouble-quotation-marks"></i>
                <p v-html="item.quotations"></p>
              </div>
              <p class="speech--rich-text" v-html="item.describe"></p>
              <div class="speech-actions-bl" v-if="item.speech_id">
                <div class="watch_btn" @click="gotoSpeech(item.speech_id)">观看视频</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import requestApi from '@/service';

export default {
  name: 'ActivityDetail',
  components: {
    VideoPlayer,
  },
  data() {
    return {
      pageData: {},
      screeningData: {},
      activity_date_items: {},
      videoData: {},
      video: {
        title: '黄晓丹《和诗人一起梦游》录制 | 一席大院儿007',
        activity_address: '东郎电影创意产业园D101',
        content: `1月7日、8日，我们邀请一席第739位讲者黄晓丹来录制第十门万象课程——《和诗人一起梦游》。黄晓丹，江苏无锡人，江南大学人文学院副教授，硕士生导师。苏州大学古代文学硕士，师从罗时进教授；南开大学古代文学博士，师从叶嘉莹教授；加拿大吉尔大学联合培养博士，师从方秀洁教授。她擅长以敏锐的直觉，潜入古代诗人的内心，感受那些距离我们时年遥远的诗句，在字词之间引起的心灵共振。她尤其会透过古诗词中微小的细节，破解古人留下的密码，拨开他们生活的褶皱，抵达古今共通的情感体验。黄晓丹出版的第一本书《诗人十四个》，用古诗词阐释友情、孤独、情欲、死亡、别离，借由十四位诗人之眼看他们的渴求、他们的接纳，与他们生命的抉择，入选2019豆瓣年度文学榜单，单向街年度文学批评榜单，经济人读书会十大好书。`,
      },
      speakers: [
        {
          title: '讲者介绍',
          data: [], // 讲者信息
        },
        {
          title: '讲者介绍',
          data: [],
        },
        {
          title: '讲者介绍',
          data: [],
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/activity/detail') {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.activityId = +this.$route.query.id;
      // this.getScreening();
      this.getData();
      this.initScrollTop();
    },
    /**
     * @description: 获取场次信息
     */
    getScreening() {
      const url = `/v3/api/h5/activity/${this.activityId}/screening/`;
      requestApi(url).then(({ screenings }) => {
        this.screeningData = this.handleScreening(screenings);
      });
    },
    /**
     * @description: 获取现场详情
     */
    getData() {
      const url = `/v3/api/site/activity/${this.activityId}/detail/`;
      requestApi(url).then(({ activity }) => {
        const { price, title, status, activity_address, speakers, activity_date_items} = activity;
        this.pageData = {
          price,
          title,
          status,
          activity_address,
          activity_date_items
        };
        this.videoData = {
          cover: activity.cover,
          videoUrls: activity.video_url,
        };
        this.speakers[0].data = speakers;
        this.handleSpeakerData();
        // 使用解构后的activity_date_items，而不是this.activity_date_items
        this.screeningData = this.handleScreening(activity_date_items);
      });
    },
    async getRichText(id) {
       const res = await requestApi(`/v3/api/site/speaker/${+id}/describe/`);
      return res.describe;
    },
    /**
     * @description: 处理场次逻辑
     * 兼容两种数据结构：
     * 1. activity_date_items: [
     *    {
     *      "date": "2025\u5e7409\u670813\u65e5\uff08\u5468\u516d\uff09",
     *      "begin_time": "12:30",
     *      "end_time": "19:30"
     *    }
     *   ]
     */
    handleScreening(data) {
      console.log('handleScreening received data:', data); // 添加日志检查数据
      const map = {};
      
      // 检查是否为Vue的Observer对象，如果是则取其raw对象
      if (data && data.__ob__) {
        // Vue响应式对象，尝试获取原始数据
        data = data.valueOf();
      }
      
      if (!data || !Array.isArray(data)) {
        console.log('handleScreening: data is null, undefined or not an array:', data);
        return map;
      }
      
      for (const item of data) {
        console.log('Processing item:', item); // 添加日志检查每一项数据
        // 使用activity_date_items结构
        const date = item.date;
        if (!date) {
          console.log('Item does not have a date field:', item);
          continue; // 跳过没有date字段的项目
        }
        if (!map[date]) map[date] = [];
        map[date].push({
          date: date,
          label: `${item.begin_time} - ${item.end_time}`,
        });
      }
      
      console.log('Final map:', map); // 添加日志检查最终结果
      return map;
    },
    async handleSpeakerData(data) {
      // 不需要了，改成接口直接返回
      // for (let i = 0; i < this.speakers.length; i += 1) {
      //   for (let j = 0; j < this.speakers[i].data.length; j += 1) {
      //     try {
      //       const richText = await this.getRichText(this.speakers[i].data[j].id);
      //       this.$set(this.speakers[i].data[j], 'richText', richText);
      //     } catch (error) {
      //       console.error(`Failed to get rich text for speaker id ${this.speakers[i].data[j].id}:`, error);
      //       // 设置一个默认的空值，避免界面出错
      //       this.$set(this.speakers[i].data[j], 'richText', '');
      //     }
      //   }
      // }
      return data;
    },
    gotoSpeech(id) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.video-right-bl {
  background: $C1;
  padding: 24px;
  width: 28%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .info-wrap {
    flex: 1;
  }
  .video-title {
    font-size: 24px;
    font-family: HYXinRenWenSongW;
    font-weight: 800;
    text-align: left;
    margin-bottom: 25px;
  }
  .activity-list {
    .activity-item {
      width: 100%;
      color: $C13;
      font-size: 14px;
      margin-bottom: 5px;
      .activity-date-wrap {
        margin-bottom: 3px;
        display: block;
        width: 100%;
        text-align: left;
        box-sizing: border-box;
        .activity-date_label {
          width: 44px;
          display: inline-block;
        }
      }
      .activity-info {
        padding-left: 44px;
      }
    }
  }
  .address {
    color: $C13;
    font-size: 14px;
    .label {
      width: 44px;
      display: inline-block;
    }
  }
  .video-actions-bl {
    position: relative;
    width: 100%;
    text-align: center;
    .buy_class-btn {
      border: none;
      outline: none;
      width: 180px;
      height: 50px;
      line-height: 50px;
      background: $C2;
      color: $C1;
      text-align: center;
      cursor: pointer;
      font-family: HYXinRenWenSongW;
      opacity: 0.9;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.content {
  .detail-bl {
    display: flex;
    align-items: stretch;
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .main-tlte {
    font-size: 24px;
    font-family: HYXinRenWenSongW;
    font-weight: 800;
    margin-top: 40px;
    margin-bottom: 25px;
  }
  .left-bl {
    width: 270px;
    .speaker_photo {
      width: 100%;
      height: auto;
      min-height: 150px;
    }
    .bottom-area {
      background: $C15;
      box-sizing: border-box;
      text-align: center;
      padding-bottom: 20px;
      .speaker_name {
        font-size: 24px;
        padding: 20px 0 6px;
      }
      .speaker_intro {
        padding: 5px 20px;
        font-size: 14px;
        text-align: center;
        & > span {
          width: auto;
          text-align: justify;
          display: inline-block;
        }
      }
    }
  }
  .right-bl {
    padding: 20px 40px 10px 40px;
    flex: 1;
    background: $C1;
    .intro-bl {
      font-size: 16px;
      color: $C13;
      .activity-list {
        .activity-item {
          & > span {
            display: block;
          }
        }
      }
    }
    .speech--rich-text {
      color: $C3;
      font-size: 16px;
      text-align: justify;
      flex: 1;
    }
    .speech-actions-bl {
      width: 100%;
      text-align: right;
      border-top: 1px dashed $C3;
      padding: 15px 0px 5px;
      .watch_btn {
        display: inline-block;
        width: 99px;
        height: 35px;
        background: $C2;
        color: $C1;
        text-align: center;
        line-height: 35px;
        font-size: 15px;
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
}
</style>
